export enum CampaignOriginType {
  Event = 1,
  Campaign = 2
}
